<template>
    <div>
        <label class="m-0">
            <strong>Checkout endpoint</strong>
            <input type="text" v-model="checkoutEndpoint" class="form-control" placeholder="https://">
        </label>
    </div>
</template>

<script>
    import endpointWatcher from './endpointWatcher';

    export default {
        name: "CheckoutEndpointConfigurator",
        props: {
            localStorageKey: {
                default: 'devtools_events_checkout_endpoint'
            }
        },
        mounted() {
            const endpoint = this.readFromStorage();
            this.checkoutEndpoint = typeof endpoint !== 'undefined' ? endpoint : '';
        },
        watch: {
            checkoutEndpoint: function (newVal) {
                this.persist(newVal);
                endpointWatcher.update(newVal);
            }
        },
        methods: {
            readFromStorage () {
                if (window.localStorage.hasOwnProperty(this.localStorageKey)) {
                    return window.localStorage.getItem(this.localStorageKey);
                }

                return undefined;
            },
            persist (value) {
                window.localStorage.setItem(this.localStorageKey, value);
            }
        },
        data: () => ({
            checkoutEndpoint: ''
        })
    };
</script>

<style scoped>

</style>
